export default {
  max: 255,
  emails: 2000,
  default: 100,
  email_max: 50,
  password_max: 50,
  password_min: 6,
  copyright: 4000,
  percentage: 2,
  float_max: 10,
  button_name: 20,
  max_projects_directory: 500,
  popupBody: {
    maxLength: 5000,
  },
  opcoHeaderMessage: {
    maxLength: 110,
  },
  opcoUrlSite: {
    maxLength: 2000,
  },
  supportUrl: {
    maxLength: 2000,
  },
  popupBodyURL: {
    maxLength: 2000,
  },
  popupBodyURLApp: {
    maxLength: 2000,
  },
  productFeedbackReason: {
    maxLength: 40,
  },
};
